import React, { useEffect, useState } from 'react';

import { PatientDetails, VideoCallButton } from '../../components/common/patientDetails';

import {
    clearData,
    flexiDeliverRemovingPageNumber,
    fetchFlexiDeliver
} from '../../services/slices/dispense/flexiDeliver';

import {
    onhandleConfirmDelivery,
    onhandleMissedDelivery
} from '../../utils/helper/deliveriesHelper';

import { handleToggleRXData, refreshCurrentLocation } from '../../utils/helper/helper';
import { useAuthSelector } from '../../services/selectors/authSelector';

import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import { useCustomStates } from '../../hooks/useCustomStates';
import { DispenseRxData } from '../../components/common/dispenseRxData';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';
import { clearUpdateDeliveryUserMessage } from '../../services/slices/dispense/updateDeliveryStatus';
import { MissedDeliveryConfirmation } from '../../components/common/routeConfirmation';
import { RxStatusWarningModal } from '../../components/common/rxStatusWarningModal';

import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBox from '../../components/common/searchBox';
import PageNotFound from '../notFound/pageNotFound';

import * as routeNames from '../../routes/routeName'
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'
import * as Messages from '../../components/common/AllConfirmationMessages'

const Flexi_delivery = () => {

    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();

    const { pharmacyId, pharmacyInspectionMode, flexiUser } = useAuthSelector()

    const { flexiDeliverResponse,
        validateReturnedPatchesResponse,
        pharmacist_assistant_status,
        confirmDeliveryResponse,
        updateDeliveryListResponse,
    } = useAllSelector();

    const { comment,
        setComment,

        cordinate,
        setCordinate,

        isRefused,
        setIsRefused,

        openIndex,
        setOpenIndex,

        patientSignature,
        setPatientSignature,

        pharmacistSignature,
        setPharmacistSignature,

        showErrorToast,
        setShowErrorToast,

        loading,
        setLoading,

        showSuccessToast,
        setShowSuccessToast,

        showComment,
        setShowComment,

        showPatientSignature,
        setShowPatientSignature,

        showPharmacistSignature,
        setShowPharmacistSignature,

        showData,
        setShowData,

        apiCallMade,
        setApiCallMade,

        showToast,
        setShowToast,

        missedDeliveryConfirmation,
        setMissedDeliveryConfirmation,

        missedData,
        setMissedData,

        missedExplanation,
        setMissedExplanation,

        missedExplanationError,
        setMissedExplanationError,

        missedDeliverErrorToast,
        setMissedDeliveryErrorToast,

        signatureErrors,
        setSignatureErrors,

        covid19,
        setCovid19,

        isTransferRequest,
        setIsTransferRequest,

        loadMore,
        setLoadMore,

        delveryDoneByAnotherDriver,
        setDeliveryDoneByAnotherDriver,

        missedIndex,
        setMissedIndex,

        patientId,
        setPatientID,

        pId,
        setPId,

        consultation,
        setConsultation,

        newRxCounsellingValues,
        setNewRxCounsellingValues,

        isPatientVerified,
        setIsPatientVerified,

        selectedDoses,
        setSelectedDoses,

        unconsumedDoseEntries,
        setUnconsumedDoseEntries,

        unconsumedDoseErrors,
        setUnconsumedDoseErrors
    } = useCustomStates()

    const [flexiProofImages, setFlexiProofImages] = useState({})
    const [copayPaymentOptions, setCopayPaymentOptions] = useState({})

    // RX Status Warning Modal States
    const [showRxStatusWarning, setShowRxStatusWarning] = useState(false);
    const [rxStatusData, setRxStatusData] = useState([]);
    const [pendingDeliveryData, setPendingDeliveryData] = useState(null);
    const [pendingDeliveryIndex, setPendingDeliveryIndex] = useState(null);
    const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([]);
    const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
        pharmacyId,
        enabled: Boolean(
            pharmacyId &&
            !flexiDeliverResponse?.loading &&
            Array.isArray(flexiDeliverResponse?.data) &&
            flexiDeliverResponse.data.length > 0
        ),
        refreshKey: 'flexi-deliver',
    })

    const handleDropdownToggle = (index, data) => {
        setConsultation(null)
        setNewRxCounsellingValues([])
        setSelectedDoses({})
        if (openIndex !== index) {
            refreshCurrentLocation(setCordinate)
            const rxIds = data?.patients_win_rx_data?.map((r) => r.id).filter(Boolean) || []
            setSelectedDeliverRxIds(rxIds)
        }
        handleToggleRXData(
            index,
            data,
            openIndex,
            setOpenIndex,
            dispatch,
            setSignatureErrors,
            setShowData,
            RemoveAllPatchesId,
            setPatientSignature,
            setShowComment,
            setShowPatientSignature,
            setShowPharmacistSignature,
            setPharmacistSignature,
            setComment,
            setIsPatientVerified,
            setUnconsumedDoseEntries,
            setUnconsumedDoseErrors,
            setMissedExplanation,
            setMissedExplanationError,
            setPId,
            pharmacyId
        )
        handleWarningCancel()
    }

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true)
            if (!apiCallMade) {
                dispatch(clearData())
                dispatch(flexiDeliverRemovingPageNumber())
                dispatch(fetchFlexiDeliver({
                    page: 1,
                    pharmacy_id: pharmacyId,
                    setLoading: setLoading
                }))
                setApiCallMade(true)
            }
        }
        return () => { }
    }, [])

    // Function to check for RX status warnings
    const checkRxStatus = (patientData) => {

        const warningRxs = [];

        if (patientData?.patients_win_rx_data.length > 0) {
            // Debug: Log the first RX to see available fields

            patientData?.patients_win_rx_data.forEach(rx => {
                // Check for various possible status fields that might contain 'S' (Stopped) or 'Tsf' (Transferred)
                const statusFields = [rx?.pharmacyWinrxRxEs?.rxstat];

                const hasWarningStatus = statusFields.some(status =>
                    status === 'S' || status === 'Tsf' || status === 's' || status === 'tsf'
                );

                if (hasWarningStatus) {
                    warningRxs.push({
                        rxnumber: rx.rxnumber,
                    });
                }
            });
        }

        return warningRxs;
    };

    const handleConfirmDelivery = (patientData, index) => {
        // Check for RX status warnings first
        const warningRxs = checkRxStatus(patientData);

        // For testing purposes - uncomment the next line to always show warning
        // const warningRxs = [{ rxnumber: 'TEST123', status: 'S', drug: 'Test Drug' }];

        if (warningRxs.length > 0) {
            // Show warning modal
            setRxStatusData(warningRxs);
            setPendingDeliveryData(patientData);
            setPendingDeliveryIndex(index);
            setShowRxStatusWarning(true);
        }

        else {
            // Proceed with normal delivery
            proceedWithDelivery(patientData, index);
        }
    };

    const proceedWithDelivery = (patientData, index) => {
        onhandleConfirmDelivery(patientData,
            index,
            pharmacyId,
            null,
            patientSignature,
            pharmacistSignature,
            cordinate,
            comment,
            dispatch,
            setLoading,
            setOpenIndex,
            setShowErrorToast,
            setShowSuccessToast,
            pharmacyInspectionMode,
            isRefused,
            covid19,
            'flexi_deliver',
            setIsRefused,
            setSignatureErrors,
            validateReturnedPatchesResponse,
            isTransferRequest,
            setIsTransferRequest,
            pharmacist_assistant_status,
            consultation,
            newRxCounsellingValues,
            selectedDoses,
            flexiProofImages,
            copayPaymentOptions,
            null,
            isPatientVerified,
            selectedDeliverRxIds,
            unconsumedDoseEntries,
            setUnconsumedDoseErrors
        );
        handleWarningCancel()
    };

    const handleWarningConfirm = () => {
        setShowRxStatusWarning(false);
        if (pendingDeliveryData && pendingDeliveryIndex !== null) {
            proceedWithDelivery(pendingDeliveryData, pendingDeliveryIndex);
        }
    };

    const handleWarningCancel = () => {
        setShowRxStatusWarning(false);
        setRxStatusData([]);
        setPendingDeliveryData(null);
        setPendingDeliveryIndex(null);
    };

    const handleMissedDelivery = () => {
        onhandleMissedDelivery(pharmacyId,
            missedData,
            missedIndex,
            dispatch,
            setOpenIndex,
            setMissedDeliveryErrorToast,
            setMissedDeliveryConfirmation,
            missedExplanation,
            setMissedExplanation,
            setMissedExplanationError,
            "today_missed",
            "flexi_deliver",
            selectedDoses,
            selectedDeliverRxIds,
            cordinate)
    }

    const fetchMoreData = () => {
        if (flexiDeliverResponse?.currentPage < flexiDeliverResponse?.totalPages) {
            setLoadMore(true)
            dispatch(fetchFlexiDeliver({
                page: flexiDeliverResponse?.currentPage + 1,
                pharmacy_id: pharmacyId,
                setLoading: setLoading,
                setLoadMore: setLoadMore
            }))
        }
    }

    const refreshFlexiDeliveries = () => {
        if (!pharmacyId || flexiDeliverResponse?.loading) return
        setOpenIndex(null)
        setLoading(true)
        dispatch(clearData())
        dispatch(flexiDeliverRemovingPageNumber())
        dispatch(fetchFlexiDeliver({ page: 1, pharmacy_id: pharmacyId, setLoading }))
    }

    return (
        <>
            {pharmacyId ? <>
                {flexiDeliverResponse?.data?.length > 0 &&
                    <InfiniteScroll
                        dataLength={flexiDeliverResponse?.data?.length}
                        next={fetchMoreData}
                        hasMore={flexiDeliverResponse?.currentPage <= flexiDeliverResponse?.totalPages}
                    />
                }

                <div className="app-wrapper flex justify-center">
                    <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                        <div className="relative p-4" >
                            <Common.TopBar />
                                <div className="title-row my-2" >
                                    <h1 className="text-xl font-bold">Flexi Deliver</h1>
                                </div>

                            {flexiUser ? null : <>
                                <div className="flex gap-3 mb-3">
                                    <SearchBox pharmacyId={pharmacyId} onRefresh={refreshFlexiDeliveries} isRefreshing={flexiDeliverResponse?.loading && loading} />
                                </div>
                            </>}

                            <div className="routes-list">

                                {(flexiDeliverResponse?.loading && loading) ?

                                    <div className='flex justify-center h-96'>
                                        <Loading.LoadingView />
                                    </div> :

                                    flexiDeliverResponse?.error !== null ?
                                        <div className='flex  justify-center pb-4 mb-4'>
                                            <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                        </div> :

                                        (flexiDeliverResponse?.data?.length === 0 && !flexiDeliverResponse?.loading) ?
                                            <p className='flex  justify-center pb-4 pt-3 h-96'>No more deliveries for today.</p>
                                            :

                                            flexiDeliverResponse?.data?.map((data, index) => {
                                                const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
                                                const isRouteAllowed = data?.route_access?.allowed !== false;
                                                const appointmentDelivery = isRouteAllowed ? getMatchedAppointmentDelivery(data) : null;
                                                return (
                                                <React.Fragment key={index}>

                                                    <div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
                                                        <PatientDetails
                                                            data={data}
                                                            patientImg={data.profile_image}
                                                            totalRxData={data?.patients_win_rx_data?.length}
                                                            index={index}
                                                            openIndex={openIndex}
                                                            onDropdownToggle={handleDropdownToggle}
                                                        >
                                                            <>
                                                                <DispenseRxData
                                                                    rxData={data?.patients_win_rx_data}
                                                                    signatureErrors={signatureErrors}
                                                                    type="new_rx"
                                                                    newRxCounsellingValues={newRxCounsellingValues}
                                                                    setNewRxCounsellingValues={setNewRxCounsellingValues}
                                                                    patientData={data}
                                                                    selectedDoses={selectedDoses}
                                                                    setSelectedDoses={setSelectedDoses}
                                                                    hideFlexi={false}
                                                                    flexiProofImages={flexiProofImages}
                                                                    setFlexiProofImages={setFlexiProofImages}
                                                                    copayPaymentOptions={copayPaymentOptions}
                                                                    setCopayPaymentOptions={setCopayPaymentOptions}
                                                                    selectedDeliverRxIds={selectedDeliverRxIds}
                                                                    setSelectedDeliverRxIds={setSelectedDeliverRxIds}
                                                                    unconsumedDoseEntries={unconsumedDoseEntries}
                                                                    setUnconsumedDoseEntries={setUnconsumedDoseEntries}
                                                                    unconsumedDoseErrors={unconsumedDoseErrors}
                                                                    setUnconsumedDoseErrors={setUnconsumedDoseErrors}
                                                                    isActiveDeliverRxCard={openIndex === index}
                                                                />

                                                                {patientId !== data?.id ? <>
                                                                    {showData &&
                                                                        <React.Fragment>
                                                                            <Common.Comment showComment={showComment}
                                                                                setShowComment={setShowComment}
                                                                                setComment={setComment} comment={comment} />

                                                                            <Common.DeliveryConsultationDropdown consultation={consultation}
                                                                                setConsultation={setConsultation} />

                                                                            <Common.PatientSignature patientSignature={patientSignature}
                                                                                setPatientSignature={setPatientSignature}
                                                                                showPatientSignature={showPatientSignature}
                                                                                setShowPatientSignature={setShowPatientSignature}
                                                                                isRefused={isRefused}
                                                                                setIsRefused={setIsRefused}
                                                                                isPatientVerified={isPatientVerified}
                                                                                setIsPatientVerified={setIsPatientVerified}
                                                                                signatureErrors={signatureErrors}
                                                                                setSignatureErrors={setSignatureErrors}
                                                                                covid19={covid19}
                                                                                setCovid19={setCovid19}
                                                                                rxData={data?.patients_win_rx_data}
                                                                            />

                                                                            {pharmacist_assistant_status === 1 ? null :
                                                                                <Common.PharmacistSignature
                                                                                    pharmacistSignature={pharmacistSignature}
                                                                                    setPharmacistSignature={setPharmacistSignature}
                                                                                    showPharmacistSignature={showPharmacistSignature}
                                                                                    setShowPharmacistSignature={setShowPharmacistSignature}
                                                                                    signatureErrors={signatureErrors}
                                                                                    setSignatureErrors={setSignatureErrors}
                                                                                />}


                                                                        </React.Fragment>
                                                                    }

                                                                    {!isRouteAllowed && (
                                                                        <div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-3 py-3 text-sm text-red-700">
                                                                            <p className="font-semibold">Delivery blocked for this patient.</p>
                                                                            <p>{data?.route_access?.reason || 'This patient has been handed over to another user.'}</p>
                                                                            {data?.assigned_route_owner?.name ? (
                                                                                <p className="mt-1 text-xs text-red-600">Assigned user: {data.assigned_route_owner.name}</p>
                                                                            ) : null}
                                                                        </div>
                                                                    )}

                                                                    <div className="flex items-center gap-2">
                                                                        <VideoCallButton
                                                                            data={data}
                                                                            variant="cta"
                                                                            disabled={noRxSelected || !isRouteAllowed}
                                                                            label="Video call"
                                                                        />
                                                                        {/* {!showData &&
                                                                            <button className="px-4 flex-1 py-2 bg-red-500 text-white rounded-md"
                                                                                onClick={() => {
                                                                                    return setMissedData(data),
                                                                                        setMissedIndex(index),
                                                                                        setMissedExplanation(''),
                                                                                        setMissedExplanationError(''),
                                                                                        setMissedDeliveryConfirmation(true)
                                                                                }}>
                                                                                Missed
                                                                            </button>} */}

                                                                        {showData ?
                                                                            
                                                                                <button
                                                                                    className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
                                                                                    disabled={noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading}
                                                                                    onClick={() => {
                                                                                        if (noRxSelected || !isRouteAllowed || confirmDeliveryResponse?.loading) return;
                                                                                        handleConfirmDelivery(data, index);
                                                                                    }}>
                                                                                    {confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loading.Loader /></p> : 'Continue'}
                                                                                </button>
                                                                            :
                                                                            <button
                                                                                className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || !isRouteAllowed) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
                                                                                disabled={noRxSelected || !isRouteAllowed}
                                                                                onClick={() => {
                                                                                    if (noRxSelected || !isRouteAllowed) return;
                                                                                    setShowData(true);
                                                                                    setTimeout(() => {
                                                                                        const windowHeight = window.innerHeight;
                                                                                        const scrollAmount = windowHeight / 2;
                                                                                        window.scrollBy({ top: scrollAmount, behavior: "smooth" });
                                                                                    }, 100);
                                                                                }}
                                                                            >
                                                                                Deliver
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                </> : null}
                                                            </>
                                                        </PatientDetails>
                                                        {appointmentDelivery ? (
                                                            <DriverAppointmentCallPanel
                                                                patient={data}
                                                                appointmentDelivery={appointmentDelivery}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </React.Fragment>);
                                        })}
                            </div>

                            {
                                loadMore &&
                                <div className='flex mb-2'>
                                    <div className="loaderss"></div>
                                </div>
                            }

                        </div>
                    </div>
                </div>

                {missedDeliveryConfirmation &&
                    <MissedDeliveryConfirmation
                        setShowConfirmationModal={setMissedDeliveryConfirmation}
                        showConfirmationModal={missedDeliveryConfirmation}
                        pharmacyId={pharmacyId} handleMissedDelivery={handleMissedDelivery}
                        missedData={missedData}
                        missedExplanation={missedExplanation}
                        setMissedExplanation={setMissedExplanation}
                        missedExplanationError={missedExplanationError}
                        setMissedExplanationError={setMissedExplanationError}
                        isSubmitting={updateDeliveryListResponse?.loading}
                    />}

                {showErrorToast && (
                    <Messages.DeliveryErrorMessages
                        setShowErrorToast={setShowErrorToast}
                        message={confirmDeliveryResponse?.userFacingErrorMessage}
                        onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
                    />
                )}
                {showSuccessToast && <Messages.DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
                {missedDeliverErrorToast && (
                    <Messages.MissedDeliveryErrorMessages
                        setMissedDeliveryErrorToast={setMissedDeliveryErrorToast}
                        message={updateDeliveryListResponse?.userFacingErrorMessage}
                        onDismiss={() => dispatch(clearUpdateDeliveryUserMessage())}
                    />
                )}

                {/* RX Status Warning Modal */}
                <RxStatusWarningModal
                    showModal={showRxStatusWarning}
                    setShowModal={setShowRxStatusWarning}
                    onConfirm={handleWarningConfirm}
                    onCancel={handleWarningCancel}
                    rxStatusData={rxStatusData}
                />

            </>
                : <PageNotFound />}
        </>
    )
}

export default Flexi_delivery
